import React from "react";
import { GhostButton } from "../Button";
import { IconFlag } from "../icons";

interface EmptyStateProps {
  display: boolean;
  canEdit: boolean;
  onAdd: () => void;
}

export function EmptyState({ display, canEdit, onAdd }: EmptyStateProps) {
  if (!display) return null;

  return (
    <div className="py-8 text-center text-content-dimmed">
      <IconFlag size={48} className="mx-auto mb-4 text-content-subtle" />
      <p className="mb-1 text-sm">Этапов пока нет</p>
      {canEdit && (
        <div>
          <p className="mb-4 text-xs">Добавь этапы для отслеживания ключевых результатов и дедлайнов</p>
          <GhostButton size="sm" onClick={onAdd}>Добавь свой первый этап</GhostButton>
        </div>
      )}
    </div>
  );
}
